export const COLOR_NAME_BRAND = 'electric blue';
export const COLOR_NAME_BLACK = 'black';
export const COLOR_NAME_DARK_GRAY = 'dark gray';
export const COLOR_NAME_MID_GRAY = 'mid gray';
export const COLOR_NAME_LIGHT_GRAY = 'light gray';
export const COLOR_NAME_PALE_GRAY = 'pale gray';
export const COLOR_NAME_WHITE = 'white';
export const COLOR_NAME_GREEN = 'green';
export const COLOR_NAME_RED = 'red';
export const COLOR_NAME_FLAMINGO = 'flamingo';
export const COLOR_NAME_MOULDY_GREEN = 'mouldy green';
export const COLOR_NAME_DIRTY_ORANGE = 'dirty orange';
export const COLOR_NAME_SECONDARY = 'secondary';
// Category colro names
export const COLOR_NAME_LIGHT_FRENCH_BEIGE = 'light french beige';
export const COLOR_NAME_PISTACHIO = 'pistachio';
export const COLOR_NAME_BLUE_GRAY = 'blue gray';
export const COLOR_NAME_POWER_BLUE = 'powder blue';
export const COLOR_NAME_GRULLO = 'grullo';
export const COLOR_NAME_LANGUID_LAVENDER = 'languid lavender';
export const COLOR_NAME_RAJAH = 'rajah';
export const COLOR_NAME_CADET_BLUE = 'cadet blue';
export const COLOR_NAME_QUEEN_PINK = 'queen pink';
export const COLOR_NAME_WATER = 'water';
export const COLOR_NAME_CADET_GREY = 'cadet grey';
export const COLOR_NAME_MOSS_GREEN = 'moss green';
export const COLOR_NAME_TERRA_COTTA = 'terra cotta';
export const COLOR_NAME_JASMINE = 'jasmine';
export const COLOR_NAME_MELON = 'melon';
export const COLOR_NAME_COPPER_PENNY = 'copper penny';

export const COMMON_COLOR_NAMES = [
  COLOR_NAME_BRAND,
  COLOR_NAME_BLACK,
  COLOR_NAME_DARK_GRAY,
  COLOR_NAME_MID_GRAY,
  COLOR_NAME_LIGHT_GRAY,
  COLOR_NAME_PALE_GRAY,
  COLOR_NAME_WHITE,
  COLOR_NAME_GREEN,
  COLOR_NAME_RED,
  COLOR_NAME_DIRTY_ORANGE,
];

export const CATEGORY_COLOR_NAMES = [
  COLOR_NAME_LIGHT_FRENCH_BEIGE,
  COLOR_NAME_PISTACHIO,
  COLOR_NAME_BLUE_GRAY,
  COLOR_NAME_POWER_BLUE,
  COLOR_NAME_GRULLO,
  COLOR_NAME_LANGUID_LAVENDER,
  COLOR_NAME_RAJAH,
  COLOR_NAME_CADET_BLUE,
  COLOR_NAME_QUEEN_PINK,
  COLOR_NAME_WATER,
  COLOR_NAME_CADET_GREY,
  COLOR_NAME_MOSS_GREEN,
  COLOR_NAME_TERRA_COTTA,
  COLOR_NAME_JASMINE,
  COLOR_NAME_MELON,
  COLOR_NAME_COPPER_PENNY,
];

export const BACKGROUND_COLOR_NAMES = [
  ...COMMON_COLOR_NAMES,
  COLOR_NAME_FLAMINGO,
] as const;

export const ALLOW_BACKGROUND_COLORS = [
  COLOR_NAME_LIGHT_GRAY,
  COLOR_NAME_PALE_GRAY,
  COLOR_NAME_WHITE,
];

export type BackgroundColor = (typeof BACKGROUND_COLOR_NAMES)[number];

export const BackgroundClassMap: Record<BackgroundColor, string> = {
  [COLOR_NAME_BRAND]: 'u-bgcolor-brand',
  [COLOR_NAME_BLACK]: 'u-bgcolor-black',
  [COLOR_NAME_DARK_GRAY]: 'u-bgcolor-dark-gray',
  [COLOR_NAME_MID_GRAY]: 'u-bgcolor-mid-gray',
  [COLOR_NAME_LIGHT_GRAY]: 'u-bgcolor-light-gray',
  [COLOR_NAME_PALE_GRAY]: 'u-bgcolor-secondary',
  [COLOR_NAME_WHITE]: 'u-bgcolor-primary',
  [COLOR_NAME_GREEN]: 'u-bgcolor-success',
  [COLOR_NAME_RED]: 'u-bgcolor-error',
  [COLOR_NAME_FLAMINGO]: 'u-bgcolor-light-danger',

  // Category colors background map
  [COLOR_NAME_LIGHT_FRENCH_BEIGE]: 'p-category-bgcolor-light-french-beige',
  [COLOR_NAME_PISTACHIO]: 'p-category-bgcolor-pistachio',
  [COLOR_NAME_BLUE_GRAY]: 'p-category-bgcolor-blue-gray',
  [COLOR_NAME_POWER_BLUE]: 'p-category-bgcolor-powder-blue',
  [COLOR_NAME_GRULLO]: 'p-category-bgcolor-grullo',
  [COLOR_NAME_LANGUID_LAVENDER]: 'p-category-bgcolor-languid-lavender',
  [COLOR_NAME_RAJAH]: 'p-category-bgcolor-rajah',
  [COLOR_NAME_CADET_BLUE]: 'p-category-bgcolor-cadet-blue',
  [COLOR_NAME_QUEEN_PINK]: 'p-category-bgcolor-queen-pink',
  [COLOR_NAME_WATER]: 'p-category-bgcolor-water',
  [COLOR_NAME_CADET_GREY]: 'p-category-bgcolor-cadet-grey',
  [COLOR_NAME_MOSS_GREEN]: 'p-category-bgcolor-moss-green',
  [COLOR_NAME_TERRA_COTTA]: 'p-category-bgcolor-terra-cotta',
  [COLOR_NAME_JASMINE]: 'p-category-bgcolor-jasmine',
  [COLOR_NAME_MELON]: 'p-category-bgcolor-melon',
  [COLOR_NAME_COPPER_PENNY]: 'p-category-bgcolor-copper-penny',
  [COLOR_NAME_DIRTY_ORANGE]: 'p-category-bgcolor-dirty-orange',
};

export const COLOR_NAMES = [
  ...COMMON_COLOR_NAMES,
  COLOR_NAME_MOULDY_GREEN,
  COLOR_NAME_DIRTY_ORANGE,
];

export type Color = (typeof COLOR_NAMES)[number];

export const ColorClassMap: Record<Color, string> = {
  [COLOR_NAME_BRAND]: 'u-color-brand',
  [COLOR_NAME_BLACK]: 'u-color-black',
  [COLOR_NAME_DARK_GRAY]: 'u-color-dark-gray',
  [COLOR_NAME_MID_GRAY]: 'u-color-mid-gray',
  [COLOR_NAME_LIGHT_GRAY]: 'u-color-light-gray',
  [COLOR_NAME_PALE_GRAY]: 'u-color-pale-gray',
  [COLOR_NAME_WHITE]: 'u-color-white',
  [COLOR_NAME_GREEN]: 'u-color-success',
  [COLOR_NAME_RED]: 'u-color-error',
  [COLOR_NAME_MOULDY_GREEN]: 'u-color-success',
  [COLOR_NAME_DIRTY_ORANGE]: 'u-color-warn',

  // Category colors map
  [COLOR_NAME_LIGHT_FRENCH_BEIGE]: 'p-category-color-light-french-beige',
  [COLOR_NAME_PISTACHIO]: 'p-category-color-pistachi',
  [COLOR_NAME_BLUE_GRAY]: 'p-category-color-blue-gray',
  [COLOR_NAME_POWER_BLUE]: 'p-category-color-powder-blue',
  [COLOR_NAME_GRULLO]: 'p-category-color-grullo',
  [COLOR_NAME_LANGUID_LAVENDER]: 'p-category-color-languid-lavender',
  [COLOR_NAME_RAJAH]: 'p-category-color-rajah',
  [COLOR_NAME_CADET_BLUE]: 'p-category-color-cadet-blue',
  [COLOR_NAME_QUEEN_PINK]: 'p-category-color-queen-pink',
  [COLOR_NAME_WATER]: 'p-category-color-water',
  [COLOR_NAME_CADET_GREY]: 'p-category-color-cadet-grey',
  [COLOR_NAME_MOSS_GREEN]: 'p-category-color-moss-green',
  [COLOR_NAME_TERRA_COTTA]: 'p-category-color-terra-cotta',
  [COLOR_NAME_JASMINE]: 'p-category-color-jasmine',
  [COLOR_NAME_MELON]: 'p-category-color-melon',
  [COLOR_NAME_COPPER_PENNY]: 'p-category-color-copper-penny',
};
